<template functional>
  <q-dialog :value="props.value" v-bind="data.attrs" @input="listeners['input']($event)">
    <q-card :style="props.styles" class="dialog-card">
      <slot name="toolbar">
        <q-bar class="toolbar">
          <span class="toolbar-title">
            <slot name="toolbar-title">{{ props.title }}</slot>
          </span>
          <q-space />
          <slot name="toolbar-actions" />
          <div v-if="!props.noCloseAction" class="btn-wrapper">
            <q-btn data-cy="close-dialog-btn" flat round icon="fal fa-times" @click="listeners['input'](false)">
              <LmTooltip>Close</LmTooltip>
            </q-btn>
          </div>
        </q-bar>
      </slot>
      <slot name="content" />
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    value: { type: Boolean, required: true },
    title: String,
    noCloseAction: Boolean,
    styles: Object
  }
}
</script>
<style lang="stylus" scoped>
@import '~@/styles/stylus/variables'

.dialog-card {
  display grid
  grid-template-rows auto 1fr
}
.toolbar {
  background: $white
  padding 0 16px
  height 46px
  font-size 21px
  color $dark
  border-radius 0
  border 1px solid $lighter-grey
  .toolbar-title {
    font-family 'Barlow', sans-serif
  }
}
.q-dialog {
  .q-dialog__inner > div {
    overflow visible
    border-radius 0
  }
}
</style>
